export async function sendQuatation(request,quatationEleSelected) {
    try {
        const response = await fetch(`http://localhost:500/mailSend/sendQuatationMail`,
                                {
                                    headers:{'Content-Type':'application/json'},
                                    method: 'POST',
                                    credentials:'include',
                                    body:JSON.stringify({
                                        request:request,
                                        quatationEleSelected:quatationEleSelected,
                                        context:"quatationSending"
                                    })
                                });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return new Error(error);
    }
}